import { render, staticRenderFns } from "./ModalEditTeam.vue?vue&type=template&id=9863cbf0&scoped=true"
import script from "./ModalEditTeam.vue?vue&type=script&lang=js"
export * from "./ModalEditTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9863cbf0",
  null
  
)

export default component.exports